import { useNavigate } from "react-router-dom";

const WINDOWS = [
  { label: "Saltwater Aquariums", short: "Saltwater", left: "4.1%", top: "9.1%", width: "25%", height: "33%", route: "/saltwater" },
  { label: "Freshwater Aquariums", short: "Freshwater", left: "37.8%", top: "9.1%", width: "24.2%", height: "33%", route: "/freshwater" },
  { label: "Reef Aquariums", short: "Reef", left: "69.4%", top: "9.6%", width: "27%", height: "32%", route: "/reef" },
  { label: "Service & Maintenance", short: "Maintenance", left: "4.1%", top: "59.45%", width: "25%", height: "33.5%", route: "/maintenance" },
  { label: "24/7 Emergency Services", short: "24/7 Emergency Services", left: "37.8%", top: "58.95%", width: "58.2%", height: "34.5%", route: "/emergency" },
];

export const About = () => {
  const navigate = useNavigate();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative w-full aspect-[3856/2148] overflow-hidden bg-[var(--ink)]"
    >
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src="/media/about-coral.mp4"
        autoPlay
        loop
        muted
        playsInline
        data-testid="about-video"
      />

      {WINDOWS.map((w, i) => (
        <div
          key={i}
          data-testid={`about-window-${i}`}
          onClick={w.route ? () => navigate(w.route) : undefined}
          className="group absolute cursor-pointer"
          style={{ left: w.left, top: w.top, width: w.width, height: w.height }}
        >
          <div className="absolute inset-0 flex items-center justify-center px-1.5 lg:px-4">
            <span className="rounded-full border border-[var(--foam)]/25 bg-[#090b1c]/85 px-2 py-1 lg:px-5 lg:py-2.5 text-center font-body font-light uppercase tracking-[0.08em] lg:tracking-[0.18em] text-[var(--foam)] text-[clamp(0.5rem,2.1vw,0.85rem)] lg:text-[clamp(0.62rem,1.05vw,1.15rem)] leading-tight opacity-100 scale-100 transition-all duration-400 lg:opacity-0 lg:scale-95 lg:group-hover:opacity-100 lg:group-hover:scale-100">
              <span className="lg:hidden">{w.short}</span>
              <span className="hidden lg:inline">{w.label}</span>
            </span>
          </div>
        </div>
      ))}

      <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-[var(--ink)] to-transparent pointer-events-none z-10" />
      <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-[var(--ink)] to-transparent pointer-events-none z-10" />
    </section>
  );
};
